import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "recipe-search-page-top-list-area" }
const _hoisted_2 = { class: "recipe-search-page-recommend" }
const _hoisted_3 = { class: "recipe-search-page-top-view" }
const _hoisted_4 = { class: "recipe-search-page-top-view-area" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RecommendListTitle = _resolveComponent("RecommendListTitle")
  const _component_TopicList = _resolveComponent("TopicList")
  const _component_CommonRecipeList = _resolveComponent("CommonRecipeList")
  const _component_SearchInputView = _resolveComponent("SearchInputView")
  const _component_CommonDialog = _resolveComponent("CommonDialog")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _withDirectives(_createVNode("div", _hoisted_2, [
        _createVNode(_component_RecommendListTitle, {
          class: "recipe-search-page-recommend-title",
          title: '閲覧履歴からのおすすめ',
          type: _ctx.SEARCH_RECIPE_TYPE.TOPIC,
          onSelectSeeMore: _ctx.clickSeeMore
        }, null, 8, ["type", "onSelectSeeMore"]),
        _createVNode(_component_TopicList, {
          class: "recipe-search-page-topic-list",
          recommendRecipes: _ctx.recommendRecipes,
          type: _ctx.SEARCH_RECIPE_TYPE.TOPIC,
          onOnClick: _ctx.selectRecipeRanking
        }, null, 8, ["recommendRecipes", "type", "onOnClick"])
      ], 512), [
        [_vShow, false]
      ]),
      _createVNode(_component_RecommendListTitle, {
        class: "recipe-search-page-recommend-title",
        title: '人気レシピ',
        type: _ctx.SEARCH_RECIPE_TYPE.RANKING,
        onSelectSeeMore: _ctx.clickSeeMore
      }, null, 8, ["type", "onSelectSeeMore"]),
      _createVNode(_component_CommonRecipeList, {
        class: "recipe-search-page-recommend-list",
        recipes: _ctx.rankingRecipes,
        onSelectRecipe: _ctx.selectRecipeRanking
      }, null, 8, ["recipes", "onSelectRecipe"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_SearchInputView, {
          inputText: _ctx.keyword,
          onSetFocus: _ctx.setFocusInputView
        }, null, 8, ["inputText", "onSetFocus"])
      ])
    ]),
    _createVNode(_component_CommonDialog, {
      showDialog: !!_ctx.handleApiError,
      title: _ctx.getApiErrorTitle,
      message: _ctx.getApiErrorMessage,
      onNegativeClick: _ctx.closeDialog,
      onPositiveClick: _ctx.retryGetRecipes
    }, null, 8, ["showDialog", "title", "message", "onNegativeClick", "onPositiveClick"])
  ]))
}